import { DefaultTheme, makeStyles } from "@material-ui/styles";
import classNames from "classnames";
import { keys, lowerCase, omit, pick } from "lodash";
import React, { useState } from "react";
import PhoneInput, { PhoneInputProps } from "react-phone-input-2";
import { countries } from "../../../store/common/models";
import { colours } from "../../../styles/colours";
import "react-phone-input-2/lib/material.css";
import "./styles.scss";
import { ErrorText } from "../../billing";

interface PhoneStructure {
  prefix?: string;
  phone?: string;
}
interface InternalProps {
  label?: PhoneInputProps["specialLabel"];
  error?: PhoneInputProps["defaultErrorMessage"];
  value?: PhoneStructure;
  onChange?: (x: PhoneStructure) => void;
  editing?: boolean;
}

const useStyles = makeStyles<DefaultTheme, { editing?: boolean }>({
  input: {
    color: (props) => (props.editing ? "currentColor" : colours.darkGrey),
    width: "100%",
  },
  root: {
    fontSize: "1em",
  },
});

export const PhoneNumber = React.forwardRef<HTMLInputElement, PhoneNumberProps>(
  ({ label, error, value, onChange, editing, ...props }, ref) => {
    const classes = useStyles({ editing });
    const [wholeValue, setWholeValue] = useState(
      value?.prefix && value?.phone ? value.prefix + value.phone : ""
    );

    return (
      <div>
        <PhoneInput
          {...props}
          country="us"
          onlyCountries={keys(countries.enum).map((x) => lowerCase(x))}
          disabled={!editing}
          isValid={() => (error ? "" : true)}
          placeholder={label}
          containerClass={classNames(
            "MuiInputBase-root",
            !editing && "Mui-disabled"
          )}
          inputClass={classes.input}
          value={wholeValue}
          onChange={(rawPhone, country) => {
            setWholeValue(rawPhone);
            const dialCode = (country as any).dialCode || "";
            const phone = rawPhone.replace(new RegExp(`^${dialCode}`), "");
            onChange &&
              onChange({
                phone: phone === "" ? undefined : phone,
                prefix: phone === "" ? undefined : dialCode,
              });
          }}
        />
        {error ? <ErrorText>{error}</ErrorText> : null}
      </div>
    );
  }
);

export type PhoneNumberProps = Omit<PhoneInputProps, keyof InternalProps> &
  InternalProps;
